module.exports = __webpack_public_path__ + "static/media/amazonaeb.a7e580cb.png";